export const logWarn = (message: string) => {
  if (process.env.NODE_ENV !== 'production') {
    console.warn(`[WARN] ${message}`);
  }
};
